// reducers.js

import { UPDATE_EMAIL, UPDATE_USERNAME, UPDATE_PASSWORD, ON_LOGGEDIN } from '../actions';

const initialState = {
  email: '',
  username: '',  // Add username to the initial state
  password: ''
};

const loginReducer = (state = initialState, action) => {
  switch (action.type) {
    case UPDATE_EMAIL:
      return {
        ...state,
        email: action.payload
      };
    case UPDATE_USERNAME:  // Handle the new action
      return {
        ...state,
        username: action.payload
      };
    case UPDATE_PASSWORD:
      return {
        ...state,
        password: action.payload
      };
    case ON_LOGGEDIN:
      return {
        ...state,
        // Handle login state changes if needed
      };
    default:
      return state;
  }
};

export default loginReducer;
